import ko from 'knockout';
import { orderBy } from 'lodash-es';
import { resolveCdnUrl } from '../cdn-url-resolver';

export class QuestionModel {
    id: KnockoutObservable<string>;
    competentionId: KnockoutObservable<string>;
    questionText: KnockoutObservable<string>;
    imageText: KnockoutObservable<string>;
    image: KnockoutObservable<any>;
    imageHash: KnockoutObservable<string>;
    secondsForImage: KnockoutObservable<number>;
    secondsForQuestion: KnockoutObservable<number>;
    quickAnswerSeconds: KnockoutObservable<number>;
    quickAnswerBonus: KnockoutObservable<number>;
    slowAnswerDeduction: KnockoutObservable<number>;
    answers: KnockoutObservableArray<QuestionAnswerModel>;

    canAddAnswer: KnockoutComputed<boolean>;
    qualityPerAnswer: KnockoutComputed<any[]>;
    imageSrc: KnockoutComputed<any>;

    constructor(params: any) {
        this.id = ko.observable<string>(params.id || '');
        this.competentionId = ko.observable<string>(params.competentionId || '');
        this.questionText = ko.observable<string>(params.questionText || '');
        this.imageText = ko.observable<string>(params.imageText || '');
        this.imageHash = ko.observable<string>(params.imageHash || '');
        this.secondsForImage = ko.observable<number>(params.secondsForImage);
        this.secondsForQuestion = ko.observable<number>(params.secondsForQuestion);
        this.quickAnswerSeconds = ko.observable<number>(params.quickAnswerSeconds);
        this.quickAnswerBonus = ko.observable<number>(params.quickAnswerBonus);
        this.slowAnswerDeduction = ko.observable<number>(params.slowAnswerDeduction);

        this.image = ko.observable<any>({
            dataURL: ko.observable<any>()
        });

        this.image().dataURL.subscribe(() => {
            this.imageHash('');
        });

        if (this.imageHash()) {
            this.image().file = ko.observable({ name: ' ' });
        }

        let answerModels: QuestionAnswerModel[] = [];
        if (params.answers) {
            answerModels = orderBy(params.answers, ['order'], ['asc'])
                .map((a: any) => new QuestionAnswerModel(a));
        }

        if (answerModels.length === 0) {
            answerModels.push(new QuestionAnswerModel());
        }

        this.answers = ko.observableArray<QuestionAnswerModel>(answerModels);

        this.canAddAnswer = ko.pureComputed(() => {
            return this.answers().length < 4;
        });

        this.imageSrc = ko.pureComputed(() => {
            if (this.image().dataURL()) {
                return this.image().dataURL();
            }

            if (this.imageHash()) {
                return resolveCdnUrl(this.imageHash());
            }

            return '';
        });
    }

    public addAnswer(): void {
        if (this.canAddAnswer()) {
            this.answers.push(new QuestionAnswerModel());
        }
    }

    public deleteAnswer(answer: QuestionAnswerModel): void {
        this.answers.remove(answer);
    }
}

export class QuestionAnswerModel {
    id: KnockoutObservable<string>;
    answer: KnockoutObservable<string>;
    score: KnockoutObservable<number>;

    constructor(params: any = {}) {
        this.id = ko.observable<string>(params.id || '');
        this.answer = ko.observable<string>(params.answer || '');
        this.score = ko.observable<number>(params.score || 0);
    }
}
